import Image from 'next/image';

import './HeroLanding.scss';
import { cn } from '@helpers/styles';
import IconCursisten from '@assets/images/courses/icon-cursisten.webp';
import IconBlijeCursist from '@assets/images/courses/icon-blije-cursist.webp';
import IconZwangerschapscursussen from '@assets/images/courses/icon-zwangerschapscursussen.webp';
import LinkWithTracking from '../../LinkWithTracking/LinkWithTracking';

export default function HeroLanding({
  title,
  content,
  buttonLink,
  buttonLabel,
  imageSrc,
  courseCount,
  imageAlt,
  trackingCategory,
  trackingAction,
  trackingName
}) {
  return (
    <section className="heroLanding">
      <HeroLanding.Intro
        title={title}
        content={content}
        buttonLink={buttonLink}
        buttonLabel={buttonLabel}
        imageSrc={imageSrc}
        imageAlt={imageAlt}
        trackingCategory={trackingCategory}
        trackingAction={trackingAction}
        trackingName={trackingName}
      />

      <div className="heroLanding-stats">
        <div className="heroLanding-stats-inner">
          <div className="heroLanding-stat">
            <Image
              src={IconCursisten}
              alt="Icon van zwangere vrouw en partner die blij zijn met de zwangerschapscursus"
              className="heroLanding-stat-icon heroLanding-stat-icon-left"
              sizes="176px"
            />
            <div className="heroLanding-stat-content heroLanding-stat-content-left">
              <div className="heroLanding-stat-content-text">10.000+</div>
              <div className="heroLanding-stat-content-label">
                blije cursisten
              </div>
            </div>
          </div>
          <div className="heroLanding-stat">
            <Image
              src={IconBlijeCursist}
              alt="Icon van blije cursist van de zwangerschapscursus"
              className="heroLanding-stat-icon heroLanding-stat-icon-middle"
              sizes="176px"
            />
            <div className="heroLanding-stat-content heroLanding-stat-content-middle">
              <div className="heroLanding-stat-content-text">8</div>
              <div className="heroLanding-stat-content-label">beoordeling</div>
            </div>
          </div>
          <div className="heroLanding-stat">
            <Image
              src={IconZwangerschapscursussen}
              alt="Icon van online zwangerschapscursussen"
              className="heroLanding-stat-icon heroLanding-stat-icon-right"
              sizes="176px"
            />
            <div className="heroLanding-stat-content heroLanding-stat-content-right">
              <div className="heroLanding-stat-content-text">{courseCount}</div>
              <div className="heroLanding-stat-content-label">cursussen</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

HeroLanding.Intro = ({
  title,
  content: Content,
  buttonLink,
  buttonLabel,
  imageSrc,
  imageAlt,
  trackingCategory,
  trackingAction,
  trackingName
}) => {
  return (
    <div
      className={cn('heroLanding-intro', {
        'heroLanding-intro-custom': !buttonLink
      })}
    >
      <div className="heroLanding-content">
        <div className="heroLanding-content-inner">
          <h1 className="heroLanding-title">{title}</h1>

          <div className="heroLanding-description">
            <Content />
          </div>

          {buttonLink &&
            (trackingCategory ? (
              <LinkWithTracking
                href={buttonLink}
                className="heroLanding-button"
                category={trackingCategory}
                action={trackingAction}
                name={trackingName}
              >
                {buttonLabel}
              </LinkWithTracking>
            ) : (
              <a href={buttonLink} className="heroLanding-button">
                {buttonLabel}
              </a>
            ))}
        </div>
      </div>

      <Image
        src={imageSrc}
        alt={imageAlt || ''}
        className="heroLanding-img"
        sizes="(min-width: 1200px) 50vw, 100vw"
        priority
        placeholder="blur"
      />
    </div>
  );
};
